import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useProductUpdates } from '@/hooks/use-product-updates';
import { useAgency } from '@/contexts/AgencyContext';

/**
 * Small "What's new" bell+badge for the top nav.
 * Hidden for users without an agency role (and non-platform admins).
 */
export function UpdatesBellButton() {
  const navigate = useNavigate();
  const { isAgencyAdmin, isPlatformSuperAdmin, agencyRole } = useAgency();
  const { unreadCount } = useProductUpdates();
  const visible = isAgencyAdmin || isPlatformSuperAdmin || !!agencyRole;
  if (!visible) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      className="ftos-header-icon h-8 w-8 rounded-md relative p-0"
      onClick={() => navigate('/updates')}
      aria-label={unreadCount > 0 ? `What's new — ${unreadCount} unread` : "What's new"}
      title="What's new"
    >
      <Sparkles className="h-4 w-4" />
      {unreadCount > 0 && (
        <span
          className="absolute top-1 right-1 min-w-[14px] h-[14px] px-1 rounded-full text-[9px] font-semibold leading-[14px] text-center text-white"
          style={{ background: 'linear-gradient(135deg,#A855F7,#22D3EE)' }}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </Button>
  );
}
